import React from 'react'
import ExtraToppingsInput from '../../ExtraTopping'
import { SectionCard } from './SectionCard'
import styles from './styles.module.css'

export const ToppingsSection = ({ extraToppings, setExtraToppings }) => (
  <SectionCard title='Extra Toppings' noPadding>
    <div className={styles.toppingsBody}>
      <ExtraToppingsInput extraToppings={extraToppings} setExtraToppings={setExtraToppings} />
    </div>
  </SectionCard>
)
